import styled from "styled-components";
import { Link } from "react-router-dom";
import { SectionText, MetaText, BodyText } from "../atoms/Text";

const Tile = styled(Link)`
  display: block;
  padding: 16px;
  border: 1px solid #DEE0E5;
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
  background: #EDEEF0;

  &:active {
    transform: translateY(1px);
  }
  &:hover {
    background: #DEE0E5;
    barder-color: #D0D4DA;
  }
`;

export function FeatureTile({ to, title, description }) {
  return (
    <Tile to={to}>
      <BodyText>{title}</BodyText>
      <MetaText>{description}</MetaText>
    </Tile>
  );
}